(function () {
  'use strict';

  /* =========================================================
     CONFIG
  ========================================================= */

  // Shopify actual product weight:
  // ONLY exactly 24000 grams qualifies.
  const QUALIFYING_WEIGHT_GRAMS = 24000;

  // Bulk Handling Surcharge Shopify variant.
  const SURCHARGE_VARIANT_ID = '44504996970561';

  // $15 per qualifying 24kg unit.
  const SURCHARGE_PRICE = 15;

  let syncing = false;
  let syncTimer = null;


  /* =========================================================
     GET CART
  ========================================================= */

  async function getCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to load cart.');
    }

    return response.json();
  }


  /* =========================================================
     CALCULATE QUALIFYING QUANTITY
  ========================================================= */

function getQualifyingQuantity(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    return 0;
  }

  return cart.items.reduce(function (total, item) {

    const weight =
      Number(item.grams) || 0;

    // 24kg AND ABOVE qualifies.
    if (
      weight >=
      QUALIFYING_WEIGHT_GRAMS
    ) {
      return (
        total +
        (Number(item.quantity) || 0)
      );
    }

    return total;

  }, 0);
}

  /* =========================================================
     FIND SURCHARGE LINE
  ========================================================= */

  function findSurchargeLine(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return null;
    }

    return (
      cart.items.find(function (item) {
        return (
          String(item.variant_id) ===
          String(SURCHARGE_VARIANT_ID)
        );
      }) || null
    );
  }


  /* =========================================================
     CUSTOMER NOTICE
  ========================================================= */

  function updateNotice(
    qualifyingQuantity
  ) {
    const notices =
      document.querySelectorAll(
        '[data-bpg-bulk-handling-notice]'
      );

    notices.forEach(function (notice) {

      if (qualifyingQuantity <= 0) {
        notice.hidden = true;
        return;
      }

      notice.hidden = false;

      const fee =
        notice.querySelector(
          '[data-bpg-bulk-fee]'
        );

      if (fee) {
        const total =
          qualifyingQuantity *
          SURCHARGE_PRICE;

        fee.textContent =
          'Bulk Handling Surcharge: $' +
          total.toFixed(2);
      }
    });
  }


  /* =========================================================
     HIDE SURCHARGE IN CART DRAWER ONLY
  ========================================================= */

  function hideSurchargeCartDrawer() {

    /*
     * IMPORTANT:
     * We ONLY search inside <cart-drawer>.
     *
     * The main Cart Page is NOT touched.
     */

    const drawer =
      document.querySelector(
        'cart-drawer'
      );

    if (!drawer) {
      return;
    }


    /* -------------------------------------------------------
       METHOD 1 — Shopify cart rows
    ------------------------------------------------------- */

    const rows =
      drawer.querySelectorAll(
        'tr, li, .cart-item, [role="listitem"]'
      );

    rows.forEach(function (row) {

      const text =
        row.textContent
          ? row.textContent
              .trim()
              .toLowerCase()
          : '';

      if (
        !text.includes(
          'bulk handling surcharge'
        )
      ) {
        return;
      }

      row.style.display = 'none';

      row.setAttribute(
        'data-bpg-hidden-surcharge',
        'true'
      );
    });


    /* -------------------------------------------------------
       METHOD 2 — Product link fallback
    ------------------------------------------------------- */

    const surchargeLinks =
      drawer.querySelectorAll(
        'a[href*="bpg-bulk-handling-surcharge"]'
      );

    surchargeLinks.forEach(
      function (link) {

        let line =
          link.closest(
            'tr, li, .cart-item'
          );

        if (line) {
          line.style.display = 'none';

          line.setAttribute(
            'data-bpg-hidden-surcharge',
            'true'
          );

          return;
        }


        /*
         * Enterprise fallback.
         * Walk upwards to find the actual
         * cart item containing quantity controls.
         */

        let parent =
          link.parentElement;

        for (
          let i = 0;
          i < 10 && parent;
          i += 1
        ) {

          const hasQuantity =
            parent.querySelector &&
            parent.querySelector(
              'quantity-input, quantity-selector, input[name*="quantity"]'
            );

          const hasRemove =
            parent.querySelector &&
            parent.querySelector(
              'cart-remove-button, button, a[href*="/cart/change"]'
            );

          if (
            hasQuantity &&
            hasRemove
          ) {
            parent.style.display =
              'none';

            parent.setAttribute(
              'data-bpg-hidden-surcharge',
              'true'
            );

            break;
          }

          parent =
            parent.parentElement;
        }
      }
    );


    /* -------------------------------------------------------
       METHOD 3 — Text fallback
    ------------------------------------------------------- */

    const elements =
      drawer.querySelectorAll('*');

    elements.forEach(function (element) {

      const text =
        element.textContent
          ? element.textContent
              .trim()
              .toLowerCase()
          : '';

      if (
        text !==
        'bulk handling surcharge'
      ) {
        return;
      }

      let parent =
        element.parentElement;

      for (
        let i = 0;
        i < 10 && parent;
        i += 1
      ) {

        const hasQuantity =
          parent.querySelector &&
          parent.querySelector(
            'quantity-input, quantity-selector, input[name*="quantity"]'
          );

        const hasRemove =
          parent.querySelector &&
          parent.querySelector(
            'cart-remove-button, button, a[href*="/cart/change"]'
          );

        if (
          hasQuantity &&
          hasRemove
        ) {
          parent.style.display =
            'none';

          parent.setAttribute(
            'data-bpg-hidden-surcharge',
            'true'
          );

          break;
        }

        parent =
          parent.parentElement;
      }
    });
  }


  /* =========================================================
     CART PAGE SURCHARGE SUMMARY
  ========================================================= */

  function updateCartSurchargeSummary(
    qualifyingQuantity
  ) {

    /*
     * Remove previous injected row.
     */

    document
      .querySelectorAll(
        '[data-bpg-cart-surcharge-summary]'
      )
      .forEach(function (element) {
        element.remove();
      });


    if (
      qualifyingQuantity <= 0
    ) {
      return;
    }


    /*
     * ONLY target the FULL CART PAGE.
     *
     * This prevents the drawer from receiving
     * this extra summary row.
     */

    const cartPage =
      document.querySelector(
        'main cart-items'
      );

    if (!cartPage) {
      return;
    }


    /*
     * Find the cart summary.
     */

    const summary =
      document.querySelector(
        '#cart-summary'
      );

    if (!summary) {
      return;
    }


    /*
     * Find "Subtotal".
     */

    const subtotalText =
      Array.from(
        summary.querySelectorAll(
          'h1, h2, h3, h4, h5, h6, span, strong, p, div'
        )
      ).find(function (element) {

        const text =
          element.textContent
            ? element.textContent
                .trim()
            : '';

        return (
          text === 'Subtotal:' ||
          text === 'Subtotal'
        );
      });


    if (!subtotalText) {
      return;
    }


    /*
     * Find the closest row.
     */

    const subtotalRow =
      subtotalText.closest(
        'div.flex, div'
      );

    if (!subtotalRow) {
      return;
    }


    /*
     * Calculate surcharge.
     */

    const total =
      qualifyingQuantity *
      SURCHARGE_PRICE;


    /*
     * Create summary row.
     */

    const row =
      document.createElement(
        'div'
      );

    row.setAttribute(
      'data-bpg-cart-surcharge-summary',
      'true'
    );

    row.style.display =
      'flex';

    row.style.justifyContent =
      'space-between';

    row.style.alignItems =
      'center';

    row.style.marginBottom =
      '12px';

    row.style.fontSize =
      '14px';


    row.innerHTML =
      '<strong>Bulk Handling Surcharge</strong>' +
      '<strong>$' +
      total.toFixed(2) +
      '</strong>';


    subtotalRow.parentNode.insertBefore(
      row,
      subtotalRow
    );
  }


  /* =========================================================
     ADD SURCHARGE — AJAX
  ========================================================= */

  async function addSurcharge(
    quantity
  ) {

    const response =
      await fetch(
        '/cart/add.js',
        {
          method: 'POST',

          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              items: [
                {
                  id:
                    Number(
                      SURCHARGE_VARIANT_ID
                    ),

                  quantity:
                    quantity,

                  properties: {
                    '_bpg_bulk_handling':
                      'Bulk Handling Surcharge'
                  }
                }
              ]
            })
        }
      );


    const data =
      await response.json();


    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Unable to add surcharge.'
      );
    }


    return data;
  }


  /* =========================================================
     UPDATE SURCHARGE — AJAX
  ========================================================= */

  async function updateSurcharge(
    lineKey,
    quantity
  ) {

    const response =
      await fetch(
        '/cart/change.js',
        {
          method: 'POST',

          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              id:
                lineKey,

              quantity:
                quantity
            })
          }
        );


    const data =
      await response.json();


    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Unable to update surcharge.'
      );
    }


    return data;
  }


  /* =========================================================
     REMOVE SURCHARGE — AJAX
  ========================================================= */

  async function removeSurcharge(
    lineKey
  ) {

    const response =
      await fetch(
        '/cart/change.js',
        {
          method: 'POST',

          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              id:
                lineKey,

              quantity:
                0
            })
          }
        );


    const data =
      await response.json();


    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'Unable to remove surcharge.'
      );
    }


    return data;
  }


  /* =========================================================
     AJAX CART UI REFRESH
  ========================================================= */

  async function refreshCartUI() {

    try {

      /*
       * Get fresh Cart Page HTML.
       *
       * This is AJAX.
       * There is NO page reload.
       */

      const response =
        await fetch(
          '/cart',
          {
            credentials:
              'same-origin',

            cache:
              'no-store',

            headers: {
              Accept:
                'text/html'
            }
          }
        );


      if (!response.ok) {
        throw new Error(
          'Unable to refresh cart UI.'
        );
      }


      const html =
        await response.text();


      const parser =
        new DOMParser();


      const doc =
        parser.parseFromString(
          html,
          'text/html'
        );


      /* =====================================================
         FULL CART PAGE ITEMS
      ===================================================== */

      const currentCartItems =
        document.querySelector(
          'main cart-items'
        );


      const newCartItems =
        doc.querySelector(
          'main cart-items'
        );


      if (
        currentCartItems &&
        newCartItems
      ) {

        currentCartItems.replaceWith(
          newCartItems
        );
      }


      /* =====================================================
         CART SUMMARY
      ===================================================== */

      const currentSummary =
        document.querySelector(
          '#cart-summary'
        );


      const newSummary =
        doc.querySelector(
          '#cart-summary'
        );


      if (
        currentSummary &&
        newSummary
      ) {

        currentSummary.replaceWith(
          newSummary
        );
      }


      /* =====================================================
         CART DRAWER
      ===================================================== */

      const currentDrawer =
        document.querySelector(
          'cart-drawer'
        );


      const newDrawer =
        doc.querySelector(
          'cart-drawer'
        );


      if (
        currentDrawer &&
        newDrawer
      ) {

        /*
         * Keep existing drawer element
         * so Shopify's drawer state is preserved.
         */

        currentDrawer.innerHTML =
          newDrawer.innerHTML;
      }


      /* =====================================================
         CART ICON / COUNT
      ===================================================== */

      const currentBubble =
        document.querySelector(
          '#cart-icon-bubble'
        );


      const newBubble =
        doc.querySelector(
          '#cart-icon-bubble'
        );


      if (
        currentBubble &&
        newBubble
      ) {

        currentBubble.replaceWith(
          newBubble
        );
      }


      /* =====================================================
         GET UPDATED CART
      ===================================================== */

      const updatedCart =
        await getCart();


      const updatedQuantity =
        getQualifyingQuantity(
          updatedCart
        );


      /* =====================================================
         RE-APPLY BPG UI
      ===================================================== */

      updateNotice(
        updatedQuantity
      );


      hideSurchargeCartDrawer();


      updateCartSurchargeSummary(
        updatedQuantity
      );


      console.log(
        '[BPG] Cart UI refreshed via AJAX.'
      );


      /*
       * Notify theme scripts.
       */

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail: {
              cart:
                updatedCart
            }
          }
        )
      );


      return updatedCart;


    } catch (error) {

      console.error(
        '[BPG] AJAX cart refresh failed:',
        error
      );


      /*
       * IMPORTANT:
       * We intentionally DO NOT use
       * window.location.reload().
       */

      return null;
    }
  }


  /* =========================================================
     MAIN SYNC
  ========================================================= */

  async function syncSurcharge() {

    if (syncing) {
      return;
    }


    syncing = true;


    try {

      const cart =
        await getCart();
        update23kgUpsell(cart);

      const qualifyingQuantity =
        getQualifyingQuantity(
          cart
        );


      console.log(
        '[BPG] Exact 24kg quantity:',
        qualifyingQuantity
      );


      /*
       * Notice.
       */

      updateNotice(
        qualifyingQuantity
      );


      /*
       * Drawer only.
       */

      hideSurchargeCartDrawer();


      /*
       * Cart Page summary only.
       */

      updateCartSurchargeSummary(
        qualifyingQuantity
      );


      const existing =
        findSurchargeLine(
          cart
        );


      const existingQuantity =
        existing
          ? Number(
              existing.quantity
            )
          : 0;


      /* =====================================================
         NO QUALIFYING PRODUCTS
      ===================================================== */

      if (
        qualifyingQuantity === 0
      ) {

        if (existing) {

          console.log(
            '[BPG] Removing surcharge:',
            existingQuantity
          );


          await removeSurcharge(
            existing.key
          );


          await refreshCartUI();
        }


        return;
      }


      /* =====================================================
         SURCHARGE ALREADY CORRECT
      ===================================================== */

      if (
        existingQuantity ===
        qualifyingQuantity
      ) {

        console.log(
          '[BPG] Surcharge already correct:',
          existingQuantity
        );


        hideSurchargeCartDrawer();


        updateCartSurchargeSummary(
          qualifyingQuantity
        );


        return;
      }


      /* =====================================================
         ADD SURCHARGE
      ===================================================== */

      if (!existing) {

        console.log(
          '[BPG] Adding surcharge:',
          qualifyingQuantity,
          '× $' +
            SURCHARGE_PRICE
        );


        await addSurcharge(
          qualifyingQuantity
        );


        /*
         * AJAX refresh.
         * NO page reload.
         */

        await refreshCartUI();


        return;
      }


      /* =====================================================
         UPDATE SURCHARGE
      ===================================================== */

      console.log(
        '[BPG] Updating surcharge:',
        existingQuantity,
        '→',
        qualifyingQuantity
      );


      await updateSurcharge(
        existing.key,
        qualifyingQuantity
      );


      /*
       * AJAX refresh.
       * NO page reload.
       */

      await refreshCartUI();


    } catch (error) {

      console.error(
        '[BPG Bulk Handling Surcharge]',
        error
      );


    } finally {

      syncing = false;
    }
  }


  /* =========================================================
     DEBOUNCE
  ========================================================= */

  function scheduleSync(
    delay
  ) {

    clearTimeout(
      syncTimer
    );


    syncTimer =
      setTimeout(
        syncSurcharge,
        typeof delay === 'number'
          ? delay
          : 800
      );
  }


  /* =========================================================
     QUANTITY / REMOVE EVENTS
  ========================================================= */

  document.addEventListener(
    'change',
    function (event) {

      const target =
        event.target;


      if (!target) {
        return;
      }


      const cartArea =
        target.closest(
          'cart-items, cart-drawer'
        );


      if (!cartArea) {
        return;
      }


      /*
       * Give Shopify Enterprise AJAX
       * cart update time to finish.
       */

      scheduleSync(
        900
      );
    }
  );


  document.addEventListener(
    'click',
    function (event) {

      const target =
        event.target;


      if (!target) {
        return;
      }


      const cartArea =
        target.closest(
          'cart-items, cart-drawer'
        );


      if (!cartArea) {
        return;
      }


      /*
       * Quantity +/- and remove buttons.
       */

      scheduleSync(
        1200
      );
    }
  );


  /* =========================================================
     SHOPIFY / ENTERPRISE CART EVENTS
  ========================================================= */

  [
    'cart:updated',
    'cart:refresh',
    'cart:change'
  ].forEach(
    function (eventName) {

      document.addEventListener(
        eventName,
        function () {

          scheduleSync(
            400
          );
        }
      );
    }
  );


  /* =========================================================
     DRAWER MUTATION OBSERVER
  ========================================================= */

  function observeCartDrawer() {

    const drawer =
      document.querySelector(
        'cart-drawer'
      );


    if (!drawer) {
      return;
    }


    const observer =
      new MutationObserver(
        function () {

          hideSurchargeCartDrawer();
        }
      );


    observer.observe(
      drawer,
      {
        childList: true,
        subtree: true
      }
    );


    /*
     * Initial hide.
     */

    hideSurchargeCartDrawer();
  }


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initialize() {

    observeCartDrawer();

    syncSurcharge();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();
  }



    function update23kgUpsell(cart) {
    const banner = document.querySelector('#bpg-23kg-upsell');

    if (!banner) {
      return;
    }

    const hasQualifyingProduct =
      cart &&
      Array.isArray(cart.items) &&
      cart.items.some(function (item) {
        return Number(item.grams) >= 24000;
      });

    banner.hidden = !hasQualifyingProduct;
  }

  /* =========================================================
     PUBLIC API
  ========================================================= */

  window.BPGBulkHandling = {

    sync:
      syncSurcharge,

    calculate:
      getQualifyingQuantity,

    refresh:
      refreshCartUI
  };

})();